<template>
  <div class="c-table" ref="planDataTable">
    <el-table
      ref="tableRef"
      border
      show-summary
      class="summary-el-table-styles common-el-table-styles"
      v-loading="loading"
      :height="props.height"
      :data="props.data"
      :summary-method="summary"
      :row-class-name="getTableRowClassNames"
      :cell-class-name="getTableCellClassNames"
      @selection-change="onSelectionChange"
      @sort-change="sortChange"
      @header-dragend="headerDragend"
    >
      <el-table-column type="selection" width="30" :selectable="rowSelectable"></el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :header-align="col.headerAlign"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
        :class-name="col.key"
      >
        <template slot-scope="{ row }">
          <div v-if="col.key === 'switch'">
            <i-Switch
              v-if="row.allowOperation && [1, 2].includes(row.mediaOptStatus)"
              v-model="row.mediaOptStatus"
              size="small"
              :loading="row.optLoading"
              :true-value="1"
              :false-value="2"
              @on-change="changeActive(row)"
            />
          </div>

          <!-- 投放计划名称 -->
          <template v-else-if="['planName'].includes(col.key)">
            <span>{{ row.planName }}</span>
            <el-tag v-if="row.isBoostPlan" class="premium-plan-tag">优投</el-tag>
          </template>

          <!-- 落地页 -->
          <template v-else-if="['pageId'].includes(col.key)">
            <el-button v-if="row[col.key]" type="text" @click="$emit('on-show', { key: col.key, row: row })">
              {{ row[col.key] }}
            </el-button>
            <span v-else>-</span>
          </template>

          <!-- 素材名称 -->
          <template v-else-if="['imageName'].includes(col.key)">
            <el-button
              style="width: 85%; overflow: hidden"
              v-if="row[col.key]"
              type="text"
              @click="$emit('on-show', { key: col.key, row: row })"
            >
              {{ row[col.key] }}
            </el-button>
            <span v-else>-</span>
            <el-button @click="$emit('change-image', row)" class="image-edit-icon" v-if="col.key === 'imageName'" type="text">
              <i class="el-icon-edit"></i>
            </el-button>
          </template>
          <!-- 多素材 -->
          <template v-else-if="['imageDetailNames'].includes(col.key)">
            <el-button v-if="row[col.key]" type="text" @click="$emit('show-multi-image', row)">
              {{ row[col.key] }}
            </el-button>
            <span v-else>-</span>
          </template>

          <div :class="statusClass(row.mediaStatus)" v-else-if="col.key === 'mediaStatus' && row.mediaStatus !== 5">
            <span class="dot-inner"></span>
            <span>{{ row.chEnumStatus }}</span>
          </div>
          <!-- 修改出价 -->
          <editable-cell
            v-else-if="col.key === 'bid' && sumColumn(row[col.key])"
            title="修改出价"
            :text="rowBidValueFmt(row[col.key])"
            :loading="row.optLoading"
            @save="onCellEdit(row, col.key, arguments)"
          />
          <!-- 修改深度出价 -->
          <editable-cell
            v-else-if="col.key === 'deepCpabid' && sumColumn(row[col.key])"
            title="修改深度出价"
            :text="rowBidValueFmt(row[col.key])"
            :loading="row.optLoading"
            @save="onCellEdit(row, col.key, arguments)"
          />
          <!-- 修改ROI系数 -->
          <editable-cell
            v-else-if="col.key === 'roiRatio' && sumColumn(row[col.key])"
            :text="rowBidValueFmt(row[col.key])"
            :loading="row.optLoading"
            @save="onCellEdit(row, col.key, arguments)"
          />

          <!-- 项目目标出价 -->
          <editable-cell
            v-else-if="col.key === 'projectTargetBid' && sumColumn(row[col.key])"
            :text="rowBidValueFmt(row[col.key])"
            :loading="row.optLoading"
            @save="onCellEdit(row, col.key, arguments)"
          />

          <!-- 项目深度目标出价 -->
          <editable-cell
            v-else-if="col.key === 'projectDeepBid' && sumColumn(row[col.key])"
            :text="rowBidValueFmt(row[col.key])"
            :loading="row.optLoading"
            @save="onCellEdit(row, col.key, arguments)"
          />

          <template v-else-if="['budget'].includes(col.key) && sumColumn(row[col.key])">
            <div style="display: flex">
              <el-popover
                v-if="showAdBudgetActionComponent(row)"
                v-model="row.showAdBudgetActionPopover"
                placement="top"
                :trigger="row.showAdBudgetActionPopover ? 'click' : 'manual'"
              >
                <div>
                  <template v-if="row.isAdReserveModifyBudget">
                    <span>
                      <span>已设置过定时任务，预算将于次日00:00改为</span>
                      <span v-if="row.bookAdBudget === 0">不限</span>
                      <span v-else>{{ row.bookAdBudget }}元</span>
                      &emsp;
                    </span>

                    <el-button type="text" @click="onReserveBudgetRemove(row, col.key)"> 删除 </el-button>
                    <el-button type="text" @click="onReserveBudgetModify(row, col.key)">编辑</el-button>
                  </template>

                  <template v-else>
                    <span>未设置定时任务</span>
                    <el-button type="text" @click="onReserveBudgetModify(row, col.key)"> 去设置 </el-button>
                  </template>
                  <el-button type="text" @click="row.showAdBudgetActionPopover = false">取消</el-button>
                </div>
                <div slot="reference" style="display: flex; margin-right: 5px">
                  <em
                    @click=";(row.showAdBudgetActionPopover = true), closeManualPopover()"
                    style="color: #1974ff; cursor: pointer"
                    class="el-icon-alarm-clock"
                    v-if="row.isAdReserveModifyBudget"
                  >
                  </em>

                  <em
                    v-else
                    style="cursor: pointer"
                    class="el-icon-alarm-clock"
                    @click=";(row.showAdBudgetActionPopover = true), closeManualPopover()"
                  >
                  </em>
                </div>
              </el-popover>

              <el-popover title="修改计划预约预算" v-model="row.showAdBudgetEditPopover" offset="40" placement="top" trigger="manual">
                <div style="display: flex; align-items: center">
                  <el-radio-group v-model="row.reserveAdBudgetRadio" class="edit-budget">
                    <el-radio :label="0"> 不限 </el-radio>
                    <el-radio :label="1">
                      <el-input-number
                        v-model="row.bookAdBudgetDup"
                        controls-position="right"
                        :disabled="row.reserveAdBudgetRadio === 0"
                        :precision="2"
                        :step="1"
                        :min="0"
                        :max="99999999"
                        style="width: 110px"
                      />
                    </el-radio>
                  </el-radio-group>

                  <div>
                    <el-button type="text" @click="onReserveBudgetSave(row, col.key)"> 保存 </el-button>
                    <el-button type="text" @click="row.showAdBudgetEditPopover = false">取消</el-button>
                  </div>
                </div>

                <div slot="reference">
                  <em>&ensp;</em>
                </div>
              </el-popover>

              <BudgetEditActionPopover
                title="修改预算"
                :value="row.newValue"
                :radio.sync="row.radioState"
                @input="saveBudget({ ...row, newValue: $event }, col.key)"
              >
                <span>{{ rowValueFmt(row[col.key]) }}</span>
              </BudgetEditActionPopover>
            </div>
          </template>

          <template v-else-if="['projectDayBudget'].includes(col.key) && sumColumn(row[col.key])">
            <div style="display: flex">
              <el-popover v-model="row.showBudgetActionPopover" placement="top" :trigger="row.showBudgetActionPopover ? 'click' : 'manual'">
                <div style="display: flex; align-items: center">
                  <template v-if="row.isProjectReserveModifyBudget">
                    <span>
                      <span>已设置过定时任务，预算将于次日00:00改为</span>
                      <span v-if="row.bookProjectBudget === 0">不限</span>
                      <span v-else>{{ row.bookProjectBudget }}元</span>
                      &emsp;
                    </span>
                    <el-button type="text" @click="onReserveBudgetRemove(row, col.key)"> 删除</el-button>
                    <el-button type="text" @click="onReserveBudgetModify(row, col.key)"> 编辑 </el-button>
                  </template>

                  <template v-else>
                    <span>未设置定时任务</span>
                    <el-button type="text" @click="onReserveBudgetModify(row, col.key)"> 去设置 </el-button>
                  </template>

                  <el-button type="text" @click="row.showBudgetActionPopover = false">取消</el-button>
                </div>
                <!-- row.projectIdForBudget 为空不能修改项目预算（腾讯广告 3.0） -->
                <div v-if="row.projectIdForBudget !== null" slot="reference" style="display: flex; margin-right: 5px">
                  <em
                    v-if="row.isProjectReserveModifyBudget"
                    style="color: #1974ff; cursor: pointer"
                    class="el-icon-alarm-clock"
                    @click=";(row.showBudgetActionPopover = true), closeManualPopover()"
                  >
                  </em>
                  <em
                    v-else
                    style="cursor: pointer"
                    class="el-icon-alarm-clock"
                    @click=";(row.showBudgetActionPopover = true), closeManualPopover()"
                  >
                  </em>
                </div>
              </el-popover>

              <el-popover title="修改预约预算" v-model="row.showBudgetEditPopover" offset="40" placement="top" trigger="manual">
                <div style="display: flex; align-items: center">
                  <el-radio-group v-model="row.reserveBudgetRadio" class="edit-budget">
                    <el-radio :label="0"> 不限 </el-radio>
                    <el-radio :label="1">
                      <el-input-number
                        v-model="row.bookProjectBudgetDup"
                        controls-position="right"
                        :disabled="row.reserveBudgetRadio === 0"
                        :precision="2"
                        :step="1"
                        :min="0"
                        :max="99999999"
                        style="width: 110px"
                      />
                    </el-radio>
                  </el-radio-group>

                  <div>
                    <el-button type="text" @click="onReserveBudgetSave(row, col.key)"> &ensp;保存 </el-button>
                    <el-button type="text" @click="row.showBudgetEditPopover = false">取消</el-button>
                  </div>
                </div>

                <div slot="reference">
                  <em>&ensp;</em>
                </div>
              </el-popover>

              <BudgetEditActionPopover
                title="修改预算"
                :value="row.newValue"
                :radio.sync="row.radioState"
                @input="saveBudget({ ...row, newValue: $event }, col.key)"
              >
                <span>{{ rowValueFmt(row[col.key]) }}</span>
              </BudgetEditActionPopover>
            </div>
          </template>
          <!-- 修改项目ROI系数 -->
          <editable-cell
            v-else-if="col.key === 'projectRoi' && sumColumn(row[col.key])"
            :text="rowBidValueFmt(row[col.key])"
            :loading="row.optLoading"
            @save="onCellEdit(row, col.key, arguments)"
          />

          <el-popover
            v-else-if="col.key === 'mediaStatus' && row.mediaStatus === 5"
            trigger="hover"
            placement="top"
            :width="420"
            @show="getAuditRejectReason(row)"
          >
            <h3 class="m-status-title">审核拒绝理由</h3>
            <template v-if="row.reasons">
              <p class="m-status-reason" v-for="(reason, index) in row.reasons" :key="index">
                {{ `${index + 1}.${reason}` }}
              </p>
            </template>
            <p v-else class="m-status-reason" v-loading="row.reasonsLoading">{{ row.auditRejectReason || '暂未获取' }}</p>
            <div :class="statusClass(row.mediaStatus)" slot="reference">
              <span class="dot-inner"></span>
              <span class="m-status-rejust">{{ row.chEnumStatus }}</span>
            </div>
          </el-popover>
          <!-- 起量功能 -->
          <template v-else-if="col.key === 'materialRaise'">
            <slot name="material-raise" :row="row"></slot>
          </template>

          <!-- 一键起量 -->
          <template v-else-if="col.key === 'raiseStatus'">
            <span class="el-icon-loading" v-if="row.optLoading"></span>
            <!-- <Icon  color="#2d8cf0" type="ios-loading" class="ivu-load-loop" /> -->
            <span v-else-if="row.raiseStatus === -1 || row.raiseStatus === null"> - </span>

            <template v-else-if="row.mediaId === MEDIAS_ENUM.TOUTIAO || row.mediaId === MEDIAS_ENUM.GDT">
              <span v-if="[AUTO_ACQUISITION_STATUS.DISABLED].includes(row.raiseStatus)">
                {{ getAutoAcquisitionRowStatusText(row) }}
              </span>
              <template v-else-if="row.raiseStatus === AUTO_ACQUISITION_STATUS.UNKNOWN">
                <span>未知&ensp;</span>
                <el-button type="text" @click="changeRaise(row)">同步</el-button>
              </template>

              <AutoAcquisitionCloseActionPopover
                title="关闭一键起量"
                v-else-if="row.raiseStatus === AUTO_ACQUISITION_STATUS.ENABLE"
                @input="onAutoAcquisitionClose($event, row)"
              >
                <el-button type="text">
                  <span>{{ getAutoAcquisitionRowStatusText(row) }}</span>
                </el-button>
              </AutoAcquisitionCloseActionPopover>

              <AutoAcquisitionEditActionPopover
                title="开启一键起量"
                v-else
                v-model="row.autoAcquisitionBudget"
                @input="onAutoAcquisitionEnable($event, row)"
              >
                <el-button type="text">
                  <span>{{ getAutoAcquisitionRowStatusText(row) }}</span>
                </el-button>
              </AutoAcquisitionEditActionPopover>
            </template>
          </template>
          <div class="control-btns" v-else-if="col.key === 'control'">
            <el-button type="text" @click="detailClick(row)">详情</el-button>

            <template v-if="[MEDIAS_ENUM.TOUTIAO].includes(row.mediaId)">
              <el-popover trigger="click" placement="top" popper-class="media-page-popover">
                <div>
                  <el-button type="text" @click="editClick('plan', row)"> 项目修改 <span class="el-icon-right"></span> </el-button>
                </div>
                <div>
                  <el-button type="text" @click="editClick('idea', row)"> 单元修改 <span class="el-icon-right"></span></el-button>
                </div>
                <el-button type="text" slot="reference">修改</el-button>
              </el-popover>

              <el-button v-if="canForwardToutiaoV3MediaPage(row)" type="text" @click="forwardMediaPage(row, 'project')">
                跳媒体
              </el-button>

              <el-popover
                v-if="!isToutiaoV3(row) && row.adIdForBudget"
                trigger="click"
                placement="top"
                popper-class="media-page-popover"
              >
                <div>
                  <el-button type="text" @click="forwardMediaPage(row, 'project')">
                    项目页面 <span class="el-icon-right"></span>
                  </el-button>
                </div>

                <div>
                  <el-button type="text" @click="forwardMediaPage(row, 'ad')"> 单元页面 <span class="el-icon-right"></span></el-button>
                </div>

                <el-button type="text" slot="reference"> 跳媒体 </el-button>
              </el-popover>

              <el-button v-if="isToutiaoV3(row)" type="text" @click="onDiagnosis(row)">诊断</el-button>
            </template>

            <!-- 腾讯广告创意优投 -->
            <template v-if="row.mediaId === MEDIAS_ENUM.GDT">
              <el-button type="text" v-loading="row.planLoading" @click="editClick('plan', row)">修改</el-button>
              <el-button type="text" @click="forwardMediaPage(row)"> 跳媒体 </el-button>
              <el-button v-if="row.isBoostPlan" type="text" @click="$emit('premium-creative-placement', row)"> 管理优投 </el-button>
              <el-button v-else type="text" @click="$emit('premium-creative-placement', row)"> 创意优投 </el-button>
            </template>
          </div>
          <div v-else-if="col.key === 'mediaName'">
            <span>{{ row[col.key] }}</span>

            <template v-if="row.mediaId === MEDIAS_ENUM.GDT">
              <span class="tencent-tag" v-if="row.subMediaId == 1">v1</span>
              <span class="tencent-tag" v-else-if="row.subMediaId == 2">ADA</span>
              <span class="tencent-tag" v-else-if="row.subMediaId == 3">v3</span>
            </template>
          </div>
          <span v-else-if="col.key === 'launchTime'">{{ row.launchTime ? moment(row.launchTime).format('YYYY-MM-DD') : '' }}</span>
          <span v-else-if="col.key === 'isMonitor'">{{ row[col.key] === 1 ? '是' : '否' }}</span>
          <span v-else-if="col.key === 'proxyAccountName'">{{ row[col.key] || '否' }}</span>
          <span v-else-if="toThousandKeys(col.key)"> {{ toThousands(row[col.key]) }} </span>
          <span v-else-if="getPercentValue(col.key)"> {{ toPercentFixed(row[col.key]) }} </span>
          <span v-else-if="col.key === 'deductRate'">
            {{ row.deductSwitch === 1 && row.deductInfo ? toPercentFixed(row[col.key]) : '否' }}
          </span>
          <span v-else>{{ row[col.key] === null || isEmpty(row[col.key]) ? '-' : row[col.key] }}</span>
        </template>
      </el-table-column>
      <template slot="empty">
        <no-data />
      </template>
    </el-table>
    <el-dialog title="同步绑定素材" :visible.sync="bindingModal" width="450px">
      <el-form label-width="120px">
        <el-form-item label="所选择计划：">
          <span>{{ selectList.length }}条</span>
        </el-form-item>

        <el-form-item label="素材数据时间：" required>
          <DateRangePicker v-model="bindForm.daterange" style="width: 230px"></DateRangePicker>
        </el-form-item>

        <el-form-item>
          <p style="font-size: 12px; color: red">注意：素材绑定提交后，绑定需要10分钟左右</p>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onMultipleBindCancel">取 消</el-button>
        <el-button type="primary" :loading="bindLoading" @click="onMultipleBindConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <betch-error v-model="betchShow" :data="betchErr" :columns="betchColumns" @on-ok="$emit('on-refresh')" />
    <betch-error v-model="betchAsync" :data="betchRaise" :columns="asyncColumns" />
    <betch-copy v-model="betchCopy" :data="betchCheck" :columns="checkColumns" />

    <!-- 批量预算修改弹窗 -->
    <BatchBudgetModifyModal
      v-if="budgetModifyModal"
      v-model="budgetModifyModal"
      :title="batchModifyModalTitle"
      :rows.sync="batchModifyRows"
      @results="onShowBatchModifyResults"
      @refresh="$emit('on-refresh')"
    ></BatchBudgetModifyModal>
    <!-- 批量预算修改结果弹窗 -->
    <BatchBudgetModifyResultsModal
      v-if="budgetModifyResultsModal"
      v-model="budgetModifyResultsModal"
      :list.sync="batchModifyResultList"
    ></BatchBudgetModifyResultsModal>

    <!-- 批量修改出价弹窗 -->
    <BatchBidModifyModal
      v-if="bidModifyModal"
      v-model="bidModifyModal"
      @refresh="$emit('on-refresh')"
      title="批量修改出价"
      :rows="batcModifyBidRows"
      @update-rows="updateBatchBidRows"
    ></BatchBidModifyModal>

    <!-- 批量一键起量 -->
    <BatchAutoAcquisitionModifyModal
      v-if="autoAcquisitionModifyModal"
      v-model="autoAcquisitionModifyModal"
      title="批量一键起量"
      :rows.sync="batchModifyAutoAcquisitionRows"
      @refresh="$emit('on-refresh')"
    ></BatchAutoAcquisitionModifyModal>

    <!-- 批量修改投放时间和日期 -->
    <BatchDateTimeModifyModal
      v-if="dateTimeModifyModal"
      v-model="dateTimeModifyModal"
      title="批量修改时间段与日期"
      :rows.sync="batchModifyDatetimeRows"
      @refresh="$emit('on-refresh')"
    ></BatchDateTimeModifyModal>

    <!-- 项目诊断弹窗 -->
    <DiagnosisDialog
      v-model="diagnosisDialogVisible"
      :account-id="diagnosisAccountId"
      :project-ids="diagnosisProjectIds"
      @refresh="$emit('on-refresh')"
    />
  </div>
</template>
<script setup>
import { defineProps, defineEmits, defineExpose, ref, computed, watch, getCurrentInstance, onMounted, defineAsyncComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import moment from 'moment'

import { MEDIAS as MEDIAS_ENUM } from '@/common/js/constants.js'
import { authCallbackHandler } from '@/common/js/gdtAuthUtil.js'
import { AUTO_ACQUISITION_STATUS } from './modify-auto-acquisition-batch/consts/index.js'

import BetchError from '@/components/converter/betch-error.vue'
import BetchCopy from '@/components/converter/betch-copy.vue'
import EditableCell from '@/components/editable-cell/index.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'

// Components
import AutoAcquisitionEditActionPopover from './modify-auto-acquisition-batch/edit-popover.vue'
import AutoAcquisitionCloseActionPopover from './modify-auto-acquisition-batch/close-popover.vue'
import BudgetEditActionPopover from './modify-budget-batch/edit-popover.vue'
import NoData from '@/components/layout/no-data.vue'
import DiagnosisDialog from './diagnosis-dialog.vue'

// Hooks
import { useTableHelpers } from './hooks/useTableHelpers'
import { useTableActions } from './hooks/useTableActions'
import { useCellEdit } from './hooks/useCellEdit'
import { useBatchBid } from './hooks/useBatchBid'
import { useBatchAutoAcquisition } from './hooks/useBatchAutoAcquisition'
import { useBatchDateTimeSchedule } from './hooks/useBatchDateTimeSchedule'

// Async Modals
const BatchBudgetModifyModal = defineAsyncComponent(() => import('./modify-budget-batch/index.vue'))
const BatchBudgetModifyResultsModal = defineAsyncComponent(() => import('./modify-budget-batch/results.vue'))
const BatchBidModifyModal = defineAsyncComponent(() => import('./modify-bid-batch/index.vue'))
const BatchAutoAcquisitionModifyModal = defineAsyncComponent(() => import('./modify-auto-acquisition-batch/index.vue'))
const BatchDateTimeModifyModal = defineAsyncComponent(() => import('./modify-datetime-batch/index.vue'))

// Setup Props & Emits
const props = defineProps({
  loading: { type: Boolean, default: false },
  height: { type: Number },
  data: { type: Array, default: () => [] },
  columns: { type: Array },
  summary: { type: Function }
})

const emit = defineEmits(['on-refresh', 'on-detail', 'on-sort', 'header-dragend', 'selection-change'])

// Instance & Router
const { proxy } = getCurrentInstance()
const route = useRoute()
const router = useRouter()

// Refs
const tableRef = ref(null)

// Diagnosis Dialog State
const diagnosisDialogVisible = ref(false)
const diagnosisAccountId = ref(null)
const diagnosisProjectIds = ref([])

const onDiagnosis = (row) => {
  diagnosisAccountId.value = row.adAccountId
  diagnosisProjectIds.value = row.projectIdForBudget ? [String(row.projectIdForBudget)] : []
  diagnosisDialogVisible.value = true
}

// Helpers
const {
  getMediaName,
  getDateRange,
  statusClass,
  sumColumn,
  rowValueFmt,
  rowBidValueFmt,
  getPercentValue,
  toThousandKeys,
  isEmpty,
  toPercentFixed,
  toThousands
} = useTableHelpers()

// Row Helpers
const rowSelectable = (row) => row.allowOperation

const TOUTIAO_V3_SUB_MEDIA_ID = 3
const TOUTIAO_V3_PROJECT_URL = 'https://ad.oceanengine.com/ad/web/std/manage'

const isToutiaoV3 = (row) => row.mediaId === MEDIAS_ENUM.TOUTIAO && Number(row.subMediaId) === TOUTIAO_V3_SUB_MEDIA_ID

const canForwardToutiaoV3MediaPage = (row) => Boolean(isToutiaoV3(row) && row.adAccountName && row.projectIdForBudget)

const buildToutiaoV3ProjectUrl = (row) =>
  `${TOUTIAO_V3_PROJECT_URL}?aadvid=${row.adAccountName}&keyword=%2522${row.projectIdForBudget}%2522`

// Table Actions Hook
const {
  selectList,
  betchErr,
  betchShow,
  betchCheck,
  betchCopy,
  betchRaise,
  betchAsync,
  bindingModal,
  bindLoading,
  bindForm,
  onSelectionChange,
  changeActive,
  changeRaise,
  closeRaise,
  detailClick,
  editClick,
  changeBetch,
  getAuditRejectReason,
  showSyncMaterialsBinding,
  onMultipleBindCancel,
  onMultipleBindConfirm,
  auditRejectReasonMap
} = useTableActions(props, emit, proxy, { getMediaName, getDateRange })

// Cell Edit & Budget Hook
const {
  budgetModifyModal,
  budgetModifyResultsModal,
  batchModifyRows,
  batchModifyResultList,
  batchModifyModalTitle,
  showAdBudgetActionComponent,
  closeManualPopover,
  showProjectBatchBudgetModal,
  showPlanBatchBudgetModal,
  onReserveBudgetModify,
  onReserveBudgetSave,
  onReserveBudgetRemove,
  onCellEdit,
  saveBudget,
  onShowBatchModifyResults,
  editBudget
} = useCellEdit(props, emit, selectList)

// Batch Bid Hook
const { batcModifyBidRows, bidModifyModal, updateBatchBidRows, showPlanBatchBidModal } = useBatchBid(selectList)

// Batch Auto Acquisition Hook
const {
  autoAcquisitionModifyModal,
  batchModifyAutoAcquisitionRows,
  showPlanAutoAcquisitionModal,
  getAutoAcquisitionRowStatusText,
  onAutoAcquisitionEnable,
  onAutoAcquisitionClose
} = useBatchAutoAcquisition(selectList, emit)

// Batch Date Time Schedule Hook
const { dateTimeModifyModal, batchModifyDatetimeRows, showPlanBatchDateTimeScheduleModal } = useBatchDateTimeSchedule(selectList)

// Watchers
watch(
  () => props.loading,
  (nVal) => {
    if (nVal) auditRejectReasonMap.clear()
  }
)

// Methods
const forwardMediaPage = (row, pageType) => {
  if (row.mediaId === MEDIAS_ENUM.GDT) {
    const tencentQuery = { operation_status: ['CALCULATE_STATUS_EXCLUDE_DEL'], search_name: row.adIdForBudget }
    const TENCENT_URL = `https://ad.qq.com/atlas/${row.adAccountName}/admanage/index?`
    const tencnetParams = { tab: 'adgroup', query: JSON.stringify(tencentQuery) }
    if (row.smartDelivery === 1) {
      tencnetParams.type = 'smart_delivery_display'
    }
    const params = new URLSearchParams(tencnetParams).toString()
    window.open(`${TENCENT_URL}${params}`, '_blank')
  }

  if (row.mediaId === MEDIAS_ENUM.TOUTIAO) {
    if (isToutiaoV3(row)) {
      if (canForwardToutiaoV3MediaPage(row)) window.open(buildToutiaoV3ProjectUrl(row), '_blank')
      return
    }

    const filterKeyword = pageType === 'project' ? row.projectIdForBudget : row.adIdForBudget
    const filterSearchType = pageType === 'project' ? 8 : 9
    const TOUTIAO_URL = `https://ad.oceanengine.com/promotion/promote-manage/${pageType}?aadvid=${row.adAccountName}&filter_keyword=%2522${filterKeyword}%2522&filter_search_type=%2522${filterSearchType}%2522`
    window.open(TOUTIAO_URL, '_blank')
  }
}

const getTableRowClassNames = ({ row }) => {
  return row.earlyWarningPlan ? 'warning-plan' : ''
}

const getTableCellClassNames = ({ row }) => {
  if (row.isBoostPlan) return 'boost-plan'
}

const sortChange = (column) => {
  emit('on-sort', column)
}

const headerDragend = (n, o, column) => {
  emit('header-dragend', { n, o, column })
}

const doLayout = () => {
  if (tableRef.value) tableRef.value.doLayout()
}

const clearSort = () => {
  if (tableRef.value) tableRef.value.clearSort()
}

const sort = (prop, order) => {
  if (tableRef.value) tableRef.value.sort(prop, order)
}

// Local betchColumns / checkColumns / asyncColumns
const betchColumns = [
  { key: 'mediaName', title: '媒体名称', tooltip: true, minWidth: 100 },
  { key: 'adName', title: '计划名称', tooltip: true, minWidth: 140 },
  { key: 'result', title: '结果', tooltip: true, minWidth: 250 }
]
const checkColumns = [
  { title: '媒体', key: 'mediaName', minWidth: 90 },
  { title: '计划', key: 'copyPlan', minWidth: 220 },
  { title: '操作', key: 'control', width: 100 }
]
const asyncColumns = [
  { title: '媒体', key: 'mediaName', minWidth: 90 },
  { title: '计划', key: 'planName', minWidth: 220 },
  { key: 'successName', title: '结果', minWidth: 120 },
  { key: 'errorMsg', title: '错误信息', tooltip: true, minWidth: 250 }
]

// Expose public methods
defineExpose({
  changeBetch,
  showPlanAutoAcquisitionModal,
  showSyncMaterialsBinding,
  showProjectBatchBudgetModal,
  showPlanBatchBudgetModal,
  showPlanBatchBidModal,
  showPlanBatchDateTimeScheduleModal,
  doLayout,
  clearSort,
  sort
})

// Lifecycle
onMounted(() => {
  const { expire_time, user_token } = route.query || {}
  if (expire_time && user_token) {
    authCallbackHandler({ expire_time, user_token }).then(() => {
      router.replace({ name: 'plandatadetail' })
      proxy.$Message.success('认证成功')
    })
  }

  if (expire_time === '0' && user_token === '') {
    proxy.$Message.warning('认证失败，请联系管理员')
    router.replace({ name: 'plandatadetail' })
  }
})
</script>
<style>
.media-page-popover {
  min-width: 65px;
}
</style>
<style lang="scss" scoped>
.c-table {
  background-color: #fff;
  margin-top: 4px;

  ::v-deep .warning-plan {
    .planName,
    .amount,
    .createRoleCost,
    .newRoleRate {
      color: red;
    }
  }

  .control-btns {
    .el-button {
      margin-left: 0;
    }
  }

  ::v-deep .el-table__cell {
    &:hover {
      .image-edit-icon {
        visibility: visible;
      }
    }
  }

  .boost-plan {
    position: relative;
    .premium-plan-tag {
      position: absolute;
      right: -4px;
      top: -2px;
      transform: scale(0.8);
      opacity: 0.8;
    }
  }

  .image-edit-icon {
    visibility: hidden;
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
  }

  .dot-inner {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    margin: 0 6px 0 0;
  }

  .tag-disabled .dot-inner {
    background-color: #bfbfbf;
  }

  .tag-success .dot-inner {
    background-color: #09cd8e;
  }

  .tag-warn .dot-inner {
    background-color: #ffa300;
  }

  .tag-error .dot-inner {
    background-color: #f1403c;
  }
}
.tencent-tag {
  display: inline-block;
  font-size: 12px;
  transform: scale(0.7);
  background: #1974ff;
  opacity: 0.7;
  color: #fff;
  padding: 2px 4px;
  border-radius: 2px;
  margin-left: 2px;
}
</style>
